import { useMutation } from '@apollo/client';
import { CANCEL_FITUP_REQUEST } from '@bechtel/client-gql';
import { CancelFitupRequestPayload, MilestoneStatusInput } from '@bechtel/types';

export function useCancelFitupRequest(
  onCompleted: (data) => void,
  onError: (error) => void,
  refetchQueries: string[]
): //@ts-ignore type changed in @apollo/client
MutationTuple<{ cancelFitup: CancelFitupRequestPayload }, { input: MilestoneStatusInput }> {
  const response = useMutation<{ cancelFitup: CancelFitupRequestPayload }, { input: MilestoneStatusInput }>(
    CANCEL_FITUP_REQUEST,
    {
      notifyOnNetworkStatusChange: true,
      onCompleted: (data) => {
        if (onCompleted) onCompleted(data);
      },
      onError: (error) => {
        if (onError) onError(error);
      },
      refetchQueries: refetchQueries,
    }
  );
  return response;
}
